import {
  commonNavigationSettings,
  NavigationSettingsType,
  readQueryParams,
} from 'utils/navigationUtils';
import { isMobilePayCallback } from 'utils/urlUtils';

// On native, settings.tsx wires this into React Navigation's getInitialURL /
// subscribe. On web there's no equivalent linking subscription, so we read the
// callback params directly off window.location on module load — that's before
// MyPaymentMethods mounts useVerifyWalletToken, which then picks the pending
// verification state out of the Zustand store and fires verifyWalletToken.
if (
  typeof window !== 'undefined' &&
  isMobilePayCallback(window.location.href)
) {
  readQueryParams(window.location.href);
}

// Web-only linking override: the BFF appends `/AIMO_ONE_FI/MOBILEPAY` to the
// returnUrl, so the MobilePay callback URL is
// `/account/my-payment-methods/AIMO_ONE_FI/MOBILEPAY?userId=...&status=...`.
// The shared `myPaymentMethods: 'account/my-payment-methods'` route is an
// exact-match string, so without this override React Navigation falls through
// to the parkScreen default. Native uses the deep-link scheme and doesn't hit
// this path, so the shared config stays untouched for iOS/Android.
const sharedLinking = commonNavigationSettings.linking;
const sharedConfig = sharedLinking?.config;
// Cast to any only for the nested-shape override below — the source config
// in navigationUtils.ts already uses `as LinkingOptions<RootStackParamList>`,
// so we mirror that style here rather than reconstructing the deep types.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sharedScreens = sharedConfig?.screens as any;
const sharedMainTabs = sharedScreens?.mainTabs;
const sharedAccountScreen = sharedMainTabs?.screens?.accountScreen;

const linking: NavigationSettingsType['linking'] =
  sharedLinking && sharedConfig && sharedAccountScreen
    ? {
        ...sharedLinking,
        config: {
          ...sharedConfig,
          screens: {
            ...sharedScreens,
            mainTabs: {
              ...sharedMainTabs,
              screens: {
                ...sharedMainTabs.screens,
                accountScreen: {
                  ...sharedAccountScreen,
                  screens: {
                    ...sharedAccountScreen.screens,
                    myPaymentMethods: {
                      path: 'account/my-payment-methods/:paymentProvider?/:paymentMethod?',
                      parse: {
                        paymentProvider: () => '',
                        paymentMethod: () => '',
                      },
                      stringify: {
                        paymentProvider: () => '',
                        paymentMethod: () => '',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      }
    : sharedLinking;

export const navigationSettings: NavigationSettingsType = {
  ...commonNavigationSettings,
  linking,
};

export default navigationSettings;
